@use "../../../node_modules/@thelabnyc/breakpoint-sass/stylesheets/breakpoint";
@use "../../styles/layout";

.title {
    font-size: 3.75rem;
    margin: 25px auto;
    width: 100%;
    text-align: center;
    text-transform: uppercase;
}

.sections {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 2rem;

    @include breakpoint.breakpoint(layout.$belowMedium) {
        grid-template-columns: 1fr;
        text-align: center;
    }
}
